import { render, staticRenderFns } from "./index.vue?vue&type=template&id=448f671c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448f671c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('448f671c')) {
      api.createRecord('448f671c', component.options)
    } else {
      api.reload('448f671c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=448f671c&scoped=true", function () {
      api.rerender('448f671c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/settings/index.vue"
export default component.exports